export default __webpack_public_path__ + "static/media/circle_gray.f5fbdd5f.png";